const nodes = [
  {
    name: "Tanssi",
    url: "wss://stagelight.tanssi-dev.network",
  },
];

const stagelight = {
  name: "Stagelight",
  value: "stagelight",
  symbol: "STAR",
  decimals: 12,
  nodes,
  useOnChainBlockData: true,
};

export default stagelight;
